import $ from 'jquery';
import blockBody from '../lib/utils/blockBody';
import shouldManageBodyStyle from '../lib/utils/should-manage-body-style';

const selectors = {
    elem: '.js-support-callback',
    form: '.js-support-callback-form'
};

const triggerBtns = document.getElementsByClassName('js-support-callback-trigger');

const states = {
    active: 'is-active'
};

const ESC_KEYCODE = 27;

let isSelectionActive = false;

let shouldBodyBeControlled = true; // the variable will help to decide whether we should delete ov-hidden class from body or not (if there's another popup is opened below it, we shouldn't do it)

const switchSelectionState = () => {
    isSelectionActive = !isSelectionActive;
};

const supportCallback = () => {
    const $document = $(document);
    const $elem = $(selectors.elem);

    if (!$elem.length) {
        return;
    }

    function cleanForm() {
        const $form = $elem.find(selectors.form);
        $form[0].reset();
    }

    function closeLocationSelection() {
        $elem.removeClass(states.active);
        switchSelectionState();
        cleanForm();
        if (shouldBodyBeControlled) {
            blockBody().unblock();
        }
    }

    function escHandler(evt) {
        if (evt.keyCode !== ESC_KEYCODE) {
            return;
        }
        closeLocationSelection();
        $document.off('keyup', escHandler);
    }

    function initLocationSelection() {
        $elem.addClass(states.active);
        switchSelectionState();
        $document.on('keyup', escHandler);
        shouldBodyBeControlled = shouldManageBodyStyle();
        if (shouldBodyBeControlled) {
            blockBody().block();
        }
    }

    Array.from(triggerBtns).forEach((elem) => {
        elem.addEventListener('click', () => {
            if (!isSelectionActive) {
                initLocationSelection();
            } else {
                closeLocationSelection();
            }
        });
    });
};

export default supportCallback;
